<template>
    <div id="app" class="my-0 py-0">
        <v-app id="inspire">
            <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                <v-card v-model="show" class="py-0">
                    <v-toolbar class="py-0 my-0" dark color="blue">
                        <v-toolbar-title class="my-0 py-0">Acta del Comité de Gestión Integrado</v-toolbar-title>
                        <v-spacer></v-spacer>
                        Código: {{ codgral }}
                    </v-toolbar>
                </v-card>
                <v-card color="blue lighten-4">
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="12" sm="12" md="12">
                                <v-text-field label="Participantes" dense v-model="participantes"></v-text-field>
                            </v-col>
                        </v-row><v-row dense>
                            <v-col cols="6" sm="4" md="3">
                                <v-menu v-model="menu" :close-on-content-click="false" :nudge-right="40"
                                    transition="scale-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field dense v-model="fecha" label="Fecha" persistent-hint
                                            prepend-icon="mdi-calendar" v-bind="attrs" v-on="on"></v-text-field>
                                    </template>
                                    <v-date-picker locale="es-ar" v-model="date" @input="menu = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" sm="4" md="3">
                                <v-text-field label="Hora Inicio" dense v-model="horai"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="4" md="3">
                                <v-text-field label="Hora fin" dense v-model="horaf"></v-text-field>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card color="blue lighten-3">
                    <v-data-table dense :headers="headers" :items="temas" locale="es-ar" class="elevation-1"
                        hide-default-footer :items-per-page="100" :footer-props="{
                itemsPerPageText: 'temas por página',
            }">

                        <template v-slot:top>
                            <v-toolbar flat>
                                <v-toolbar-title>Temas tratados</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>
                                <v-dialog v-model="dialog" max-width="950px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                                            Agregar Tema
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-title>
                                            <span class="headline">{{ formTitle }}</span>
                                        </v-card-title>

                                        <v-card-text>
                                            <v-container>
                                                <v-row dense>
                                                    <v-col cols="12" sm="6" md="3">
                                                        <v-select dense autofocus v-model="editedItem.tipo"
                                                            :items="listadotipo" label="Tipo" item-text="nombre"
                                                            item-value="valor"></v-select>
                                                    </v-col>
                                                    <v-col cols="12" sm="6" md="2">
                                                        <v-text-field dense v-model="editedItem.num"
                                                            label="Código"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" sm="12" md="7">
                                                        <v-text-field dense v-model="editedItem.descr"
                                                            label="Descripción"></v-text-field>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-card-text>

                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="blue darken-1" text @click="close">
                                                Cancelar
                                            </v-btn>
                                            <v-btn color="blue darken-1" text @click="save">
                                                Guardar
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                                <v-dialog v-model="dialogDelete" max-width="500px">
                                    <v-card>
                                        <v-card-title class="headline">Está seguro que desea borrar?</v-card-title>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                                            <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                                            <v-spacer></v-spacer>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-toolbar>
                        </template>

                        <template v-slot:item.actions="{ item }">
                            <v-icon small class="mr-2" color="purple" @click="editItem(item)">
                                mdi-pencil
                            </v-icon>
                            <v-icon small color="red" @click="deleteItem(item)">
                                mdi-delete
                            </v-icon>
                        </template>
                    </v-data-table>

                </v-card>

                <v-card color="blue" dark tile>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="success" @click.stop="guardar" :disabled="deshabilitar">Guardar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-app>
    </div>

</template>

<script>
import moment from "moment";
import axios from "../../../../src/axios-auth";
import readXlsFile from "read-excel-file";
export default {
    data: (vm) => ({
        deshabilitar: false,
        dialog: false,
        dialogDelete: false,
        valid: false,
        menu: false,
        lazy: false,
        codgral: "",
        participantes: "Zamora Walter - Asinari Silvio - Musso Marcos - Blanco Sergio -  Stein Rodrigo",
        date: moment().format("YYYY-MM-DD"),
        horai: "15:00",
        horaf: "17:30",
        temas: [],
        listadotemas: [],
        listadotipo: [
            { nombre: 'Posventa', valor: 'PV' },
            { nombre: 'No Conformidad', valor: 'NC' },
            { nombre: 'Sugerencia de Mejora', valor: 'SM' },
            { nombre: 'Auditoría Interna', valor: 'AU' },
            { nombre: 'Otros', valor: 'OT' },
        ],
        headers: [
            { text: "Tipo", value: "tipo", sortable: false },
            { text: "Código", value: "num", sortable: false },
            { text: "Descripción", value: "descr", sortable: false },
            { text: "Acciones", value: "actions", sortable: false },
        ],
        editedIndex: -1,
        editedItem: {
            tipo: "",
            num: "",
            descr: "",
        },
        defaultItem: {
            tipo: "",
            num: "",
            descr: "",
        },
    }),
    watch: {
        dialog(val) {
            val || this.close();
            console.log(this.valid);
        },
        dialogDelete(val) {
            val || this.closeDelete();
        },
    },
    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "Nueva Tema" : "Editar Tema";
        },
        fecha() {
            return this.formatDate(this.date)
        },
        show: {
            get() {
                this.cargarcodigo();
                //this.cargartemas();
            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$refs.form.resetValidation();
                    document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },
    },
    methods: {
        formatDate(date) {
            if (!date) return null;
            const [year, month, day] = date.split("-");
            return `${day}/${month}/${year}`;
        },
        parseDate(date) {
            if (!date) return null;
            const [month, day, year] = date.split("/");
            return `${day.padStart(2, "0")}-${month.padStart(2, "0")}-${year}-`;
        },

        async cargarcodigo() {
            let self = this;
            axios
                .get("/Sgi/CodigoActa?", {
                    params: {
                    },
                })
                .then((response) => {
                    self.codgral = response.data;
                })
                .catch((error) => {
                    self.codgral = "";
                    console.log(error);
                });
            await this.cargartemas();
        },

        async cargartemas() {
            if (this.codgral != "") {
                let self = this;
                axios
                    .get("/Sgi/Cargartemasacta?", {
                        params: {
                            codgral: self.codgral
                        },
                    })
                    .then((response) => {
                        self.temas = response.data;
                    })
                    .catch((error) => {
                        self.temas = [];
                        console.log(error);
                    });
            }
        },

        vaciarModels() {
            this.participantes = "";
            this.temas = [];
            this.listadotemas = [];
            this.fecha = "";
            this.hini = "";
            this.hfin = "";
        },
        editItem(item) {
            this.editedIndex = this.temas.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },

        deleteItem(item) {
            this.editedIndex = this.temas.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialogDelete = true;
        },

        deleteItemConfirm() {
            this.temas.splice(this.editedIndex, 1);
            this.closeDelete();
        },

        close() {
            this.dialog = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },

        closeDelete() {
            this.dialogDelete = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },

        save() {
            if (this.editedIndex > -1) {
                Object.assign(this.temas[this.editedIndex], this.editedItem);
            } else {
                this.temas.push(this.editedItem);
            }
            this.close();
        },

        guardar() {
            this.deshabilitar = true;
            this.$swal({
                title: "Guardar Acta",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    this.temas.forEach((element) => {
                        if (element.descr != "" && element.descr != null) {
                            this.listadotemas.push({
                                tipo: element.tipo,
                                num: element.num,
                                descr: element.descr,
                            });
                        }
                    });
                    var datos = {
                        codgral: this.codgral,
                        fecha: this.fecha,
                        hin: this.horai,
                        hfin: this.horaf,
                        presentes: this.participantes,
                        detalle: this.listadotemas,
                    };

                    let self = this;
                    axios
                        .post("/SGI/GuardarActa", datos)
                        .then((response) => {
                            self.$refs.form.resetValidation();

                            self.showAlert({
                                icon: "success",
                                title: "Acta guardada con éxito",
                                vm: self,
                            });
                            self.vaciarModels();
                            self.$emit("close");
                        })
                        .catch({});
                }
            });
        },
        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 2000,
            });
        },
    },
};
</script>
